import { useEffect, useState } from "react";
import { Download, Wand2, Trash2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { PageHeader } from "../components/AiHtml";

const KEY = "namo_schedule";
const PLATFORMS = ["Instagram", "LinkedIn", "Facebook", "X", "YouTube Shorts"];
const TYPES = ["Reel", "Carousel", "Story", "Text post", "Short video", "Blog share"];
const IDEAS = ["Behind the scenes", "Customer testimonial", "Product spotlight", "How-to tip", "Myth vs fact", "Founder story", "Offer announcement", "Industry stat", "FAQ answer", "User generated content"];
const TIMES = ["09:30", "12:30", "18:00", "20:30"];
const pick = (a) => a[Math.floor(Math.random() * a.length)];
const color = { Instagram: "border-pink-500/50", LinkedIn: "border-blue-500/50", Facebook: "border-indigo-500/50", X: "border-slate-400/50", "YouTube Shorts": "border-red-500/50" };

const autoSchedule = () => {
  const out = [];
  for (let d = 0; d < 7; d++) {
    const date = new Date(Date.now() + d * 864e5).toISOString().slice(0, 10);
    const n = 1 + Math.floor(Math.random() * 2);
    for (let k = 0; k < n; k++) out.push({ id: `${date}-${k}-${Math.random().toString(36).slice(2, 6)}`, date, time: pick(TIMES), platform: pick(PLATFORMS), type: pick(TYPES), title: pick(IDEAS), status: d === 0 ? "Scheduled" : "Draft" });
  }
  return out.sort((a, b) => (a.date + a.time).localeCompare(b.date + b.time));
};

export default function Scheduler() {
  const [posts, setPosts] = useState(() => JSON.parse(localStorage.getItem(KEY) || "[]"));
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(posts)); }, [posts]);
  const days = [...Array(7)].map((_, i) => new Date(Date.now() + i * 864e5));

  const exportCsv = () => {
    const rows = [["Date", "Time", "Platform", "Type", "Title", "Status"], ...posts.map((p) => [p.date, p.time, p.platform, p.type, p.title, p.status])];
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.map((r) => r.map((c) => `"${c}"`).join(",")).join("\n")], { type: "text/csv" }));
    a.download = "namoai-schedule.csv";
    a.click();
  };
  const cycle = (id) => setPosts((ps) => ps.map((p) => (p.id === id ? { ...p, status: { Draft: "Scheduled", Scheduled: "Published", Published: "Draft" }[p.status] } : p)));

  return (
    <div className="space-y-6">
      <PageHeader label="Scheduler" title="7-day content calendar" desc="Auto-plan a week of posts. Saved in your browser. Click a status to cycle it." right={
        <div className="flex gap-2">
          <Button data-testid="scheduler-auto-btn" onClick={() => setPosts(autoSchedule())} className="rounded-full"><Wand2 size={15} className="mr-1.5" /> Auto schedule</Button>
          <Button data-testid="scheduler-export-btn" variant="outline" onClick={exportCsv} disabled={!posts.length} className="rounded-full"><Download size={15} className="mr-1.5" /> Export CSV</Button>
        </div>
      } />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="scheduler-calendar">
        {days.map((d) => {
          const key = d.toISOString().slice(0, 10);
          const list = posts.filter((p) => p.date === key);
          return (
            <div key={key} className="card-n p-3 min-h-[220px]">
              <p className="label-mono">{d.toLocaleDateString("en-IN", { weekday: "short" })}</p>
              <p className="font-display text-2xl font-bold">{d.getDate()}</p>
              <div className="mt-3 space-y-2">
                {list.map((p) => (
                  <div key={p.id} data-testid={`schedule-post-${p.id}`} className={`rounded-lg bg-slate-900 border-l-2 ${color[p.platform]} p-2 text-xs`}>
                    <div className="flex justify-between text-slate-500 font-mono"><span>{p.time}</span><button onClick={() => setPosts((ps) => ps.filter((x) => x.id !== p.id))}><Trash2 size={11} /></button></div>
                    <p className="text-slate-100 font-medium mt-1">{p.title}</p>
                    <p className="text-slate-500">{p.platform} · {p.type}</p>
                    <button onClick={() => cycle(p.id)} className={`mt-1.5 px-2 py-0.5 rounded-full text-[10px] ${p.status === "Published" ? "bg-emerald-500/15 text-emerald-400" : p.status === "Scheduled" ? "bg-orange-500/15 text-orange-400" : "bg-slate-700/50 text-slate-400"}`}>{p.status}</button>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
